import { Suspense, lazy, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useStore } from './store';
import { Shell } from './components/Shell';
import { Toasts } from './components/Toasts';
import { ChallengeBanner } from './components/ChallengeBanner';
import { Landing } from './pages/Landing';
import { ComingSoon, isAdminUser } from './pages/ComingSoon';
import { Home } from './pages/Home';
import { Learn } from './pages/Learn';
import { Battle } from './pages/Battle';
import { Collection } from './pages/Collection';
import { Packs } from './pages/Packs';
import { Store } from './pages/Store';
import { Upload } from './pages/Upload';
import { Friends } from './pages/Friends';
import { Profile } from './pages/Profile';
import { Leaderboard } from './pages/Leaderboard';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Reset } from './pages/Reset';
import { Arena } from './arena/Arena';
const Admin = lazy(() => import('./pages/Admin').then((m) => ({ default: m.Admin })));

export function App() {
  const { user, meta, booted, bootError, retryBoot } = useStore();
  const loc = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  if (!booted) return <div className="boot"><img src="/logo.png" alt="Gooflord" width={220} /><p>Shuffling the deck…</p></div>;
  if (bootError) return <div className="boot"><div><img src="/logo.png" alt="Gooflord" width={220} /><p>Couldn't reach the Gooflord server{user ? ` (you're still signed in as ${user.display_name})` : ''}.</p><p className="small">{navigator.onLine ? bootError : "You're offline."}</p><button className="btn primary" onClick={retryBoot}>Retry</button></div></div>;
  const isAdmin = !!user?.staff;
  // pre-launch (production): only admins get the app; the server refuses everyone else too
  if (meta?.coming_soon && !isAdminUser(user)) return (
    <>
      <Routes>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<ComingSoon />} />
      </Routes>
      <Toasts />
    </>
  );
  return (
    <>
      <Routes>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/reset" element={<Reset />} />
        {!user ? (
          <Route path="*" element={<Landing />} />
        ) : (
          <>
            <Route path="/battle/:id" element={<Arena />} />
            <Route element={<Shell />}>
              <Route path="/" element={<Home />} />
              <Route path="/learn" element={<Learn />} />
              <Route path="/battle" element={<Battle />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/packs" element={<Packs />} />
              <Route path="/store" element={<Store />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/friends" element={<Friends />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              {isAdmin && <Route path="/admin" element={<Suspense fallback={<p className="chalk">Loading admin…</p>}><Admin /></Suspense>} />}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </>
        )}
      </Routes>
      <Toasts />
      {user && <ChallengeBanner />}
    </>
  );
}
